import achievement from '../assets/meaning/achievement.webp';
import autonomy from '../assets/meaning/autonomy.webp';
import compliance from '../assets/meaning/compliance.webp';
import hedonism from '../assets/meaning/hedonism.webp';
import kindness from '../assets/meaning/kindness.webp';
import power from '../assets/meaning/power.webp';
import security from '../assets/meaning/security.webp';
import stimulation from '../assets/meaning/stimulation.webp';
import tradition from '../assets/meaning/tradition.webp';
import universalism from '../assets/meaning/universalism.webp';

export const meaningRankColors = ['#071B45', '#212E57', '#4D597A'];

export const meaningImages: Record<string, string> = {
  achievement,
  autonomy,
  compliance,
  hedonism,
  kindness,
  power,
  security,
  stimulation,
  tradition,
  universalism,
};
